import { render } from "./color.vue?vue&type=template&id=2ff1448c&scoped=true"
import script from "./color.vue?vue&type=script&lang=js"
export * from "./color.vue?vue&type=script&lang=js"

import "./color.vue?vue&type=style&index=0&id=2ff1448c&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff1448c"]])

export default __exports__